
import type { VerbAndObjects } from '../types';

// OBS: NOT RESPONDING STORE, just a global state

// OBS: no need to be a class??

class TargetVerbAndObjects {
  value = <VerbAndObjects>([]);

}

export const targetVerbAndObjects = new TargetVerbAndObjects();
